module.exports = __webpack_public_path__ + "img/2.02e6df58.png";